import { render, staticRenderFns } from "./TableColumnsSelector.vue?vue&type=template&id=056f793a&"
import script from "./TableColumnsSelector.vue?vue&type=script&lang=js&"
export * from "./TableColumnsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports